import Helper, { DateFormat } from "@/services/Helper";
import { WorkOrderModel } from "./WorkOrderModel";

class WorkOrderItemModel
{
    constructor(obj?: WorkOrderItemModel)
    {
        if (obj)
        {
            Object.assign(this, obj);

            // Store date strings in private backing fields
            if (obj.LineDate)
            {
                this._LineDate = obj.LineDate + "";
            }

            // Prevent circular reference
            if (obj.WorkOrder)
            {
                this.WorkOrder = null;
            }
        }
        else
        {
            // Set defaults for new records
            this._LineDate = Helper.dateToInput(new Date(), DateFormat.Date);
            this.Status = 1;
            this.Quantity = 1;
            this.Taxable = true;
        }
    }

    public Id?: number | null;
    public WorkOrderId?: number | null;

    // Relationships
    public WorkOrder?: WorkOrderModel | null;

    // Line item details
    private _LineDate?: string | null;

    public get LineDate(): string | null
    {
        return Helper.dateToInput(this.LineDateAsDate, DateFormat.Date) || null;
    }

    public set LineDate(val: string | null)
    {
        this._LineDate = val || null;
    }

    public get LineDateAsDate(): Date | null
    {
        if (this._LineDate)
        {
            return Helper.dateFromString(this._LineDate) || null;
        }
        return null;
    }

    public Description?: string | null;
    public ItemType?: string | null; // "Labor", "Parts", "Materials", "Service"
    public Status?: number | null;
    public Quantity?: number | null;
    public UnitCost?: number | null;
    public LineTotal?: number | null;
    public LineTotalOverride?: number | null;
    public DiscountPercent?: number | null;
    public DiscountAmount?: number | null;
    public TaxRate?: number | null;
    public TaxAmount?: number | null;
    public PartNumber?: string | null;
    public SKU?: string | null;
    public Notes?: string | null;
    public SortOrder?: number | null;
    public Taxable?: boolean | null;

    // Source entity references (nullable - only one should be populated)
    public TaskId?: number | null;
    public PartId?: number | null;
    public ExpenseId?: number | null;
    public MileageId?: number | null;

    // Transient UI flags (not persisted)
    public _isEditing?: boolean;
    public _editingOverride?: boolean;
    public _originalValues?: any;

    // Computed line total
    public get CalculatedLineTotal(): number
    {
        if (this.LineTotalOverride != null)
        {
            return Number(this.LineTotalOverride);
        }

        const quantity = this.Quantity || 0;
        const unitCost = this.UnitCost || 0;
        const discountAmount = this.DiscountAmount || 0;
        const discountPercent = this.DiscountPercent || 0;
        
        let total = quantity * unitCost;
        
        // Apply discount
        if (discountAmount > 0)
        {
            total -= discountAmount;
        }
        else if (discountPercent > 0)
        {
            total -= (total * discountPercent / 100);
        }
        
        return total;
    }

    public get CalculatedTaxAmount(): number
    {
        if (!this.Taxable) return 0;
        const lineTotal = this.LineTotal || this.CalculatedLineTotal;
        const taxRate = this.TaxRate || 0;
        return lineTotal * (taxRate / 100);
    }
}

class WorkOrderItemFilter
{
    public Id?: number[];
    public WorkOrderId?: number[];
    public ItemType?: string;
    public Status?: number[];
    public IncludeWorkOrder?: boolean = false;
    public Page?: number = 0;
    public Size?: number = 100;
}

export { WorkOrderItemModel, WorkOrderItemFilter }
